import { Telefone } from './telefone';
export class TelefoneSuper {

    public telefone: Telefone;

    set Telefone(telefone: any) {
        this.telefone = new Telefone(telefone);
    }

    get obterTelefone(): Telefone {
        return this.telefone;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/telefone-super.ts